import React, { useState, useEffect, useContext } from "react";
import Button from "@mui/material/Button";
import AppContext from "../../../utils/context";
import Markdown from "react-markdown";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import { Box } from "@mui/system";
import {formatCell} from "../../../components/autocell.js";

export default function View(props) {
  const appContext = useContext(AppContext);
  const [dashboard, setDashboard] = useState("");

  return (
    <Box
      className="no-drag"
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {props?.format_data?.columns && props?.format_data?.rows && <DataGrid
        size="small"
        style={{ border: "none", flexGrow: 1 }}
        getRowHeight={() => "auto"}
        rows={props?.format_data?.rows && props.format_data.rows.map((row, index) => {
          return  { ...row, widget_table_id:index  };
        })}
        initialState={{ pagination: { paginationModel: { pageSize: 50 } } }}
        disableRowSelectionOnClick
        disableColumnResize
        pageSize={5}
        rowsPerPageOptions={[5]}
        disableSelectionOnClick
        getRowId={(row) => row.widget_table_id} // Use the first property as row ID
        columns={formatCell(props.format_data.columns)}
      />}
    </Box>
  );
}
